import { render } from "./RequestProgress.vue?vue&type=template&id=227cdaca&scoped=true&ts=true"
import script from "./RequestProgress.vue?vue&type=script&lang=ts"
export * from "./RequestProgress.vue?vue&type=script&lang=ts"

import "./RequestProgress.vue?vue&type=style&index=0&id=227cdaca&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227cdaca"]])

export default __exports__